import { router } from 'expo-router'
import { View } from 'react-native'

import { useTagsQuery } from '@/src/features/tag/services/useTagsQuery'
import { TEST_ID } from '@/src/general/constants/testId'
import { getImageUrl } from '@/src/general/utils/getImageUrl'
import { useRoutes } from '@/src/general/utils/routes'

import { CategoryCard } from './CategoryCard/CategoryCard'

export const CommunityCategories = () => {
  const { data: tags } = useTagsQuery()
  const { routes } = useRoutes()
  return (
    <View className="flex-4 flex-row flex-wrap gap-6" testID={TEST_ID.COMMUNITIES.CATEGORIES}>
      {tags?.slice(0, 4).map((tag) => (
        <CategoryCard
          isPressable
          onPress={() => router.navigate(routes.communitiesCategory(tag.slug))}
          key={tag.id}
          imageSrc={getImageUrl(tag.icon)}
          content={tag.name}
          className="max-h-[231px] flex-1 grow"
        />
      ))}
    </View>
  )
}
